export interface IExport {
  url: string;
}
